<script setup lang="ts">
import { COMBINE_HEADERS } from '@/services/consts/daily_report';
import i18n from '@/lang/i18n';

</script>
<template>
  <thead>
    <tr class="">
      <template v-for="value in COMBINE_HEADERS" :key="value.key">
        <th
          :class="value.class"
        >
          <span
            v-if="value.key !== ''"
            class="w-100 mx-auto d-flex justify-content-center"
          >
            {{ i18n.global.t(`pages.dailyReports.combineForm.list.${value.key}`) }}
          </span>
        </th>
      </template>
    </tr>
  </thead>
</template>
